import { render, staticRenderFns } from "./ReturnableOrderItemView.vue?vue&type=template&id=bc368776&"
import script from "./ReturnableOrderItemView.vue?vue&type=script&lang=js&"
export * from "./ReturnableOrderItemView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnableOrderItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports